module.exports = __webpack_public_path__ + "static/media/3.7baf2847.jpg";